// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__3OLuF","boxTitle":"Qualiphy_boxTitle__2OW0u","box":"Qualiphy_box__2gmnV","toggleWrap":"Qualiphy_toggleWrap__3w2uY"};